export var StationPassType;
(function (StationPassType) {
    StationPassType["Best"] = "best";
    StationPassType["Visible"] = "visible";
    StationPassType["All"] = "all";
})(StationPassType || (StationPassType = {}));
export const deriveStationNotificationTag = (location, typeFilter) => {
    return `${Math.floor(location.latitude).toFixed(1)},${Math.floor(location.longitude).toFixed(1)},${typeFilter}`;
};
//# sourceMappingURL=station-notifications.js.map